export default __webpack_public_path__ + "static/media/mode-0.443c7b1a.svg";